







































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { App } from '../../entities/app'
import { scrollToTop, imageCdnBaseUrl } from '@/utils/appstore'

@Component<AppstoreAppTile>({
    components: {}
})
export default class AppstoreAppTile extends Vue {
    public canUpdate = false
    @Prop({ type: Object, required: true })
    public readonly app!: App
    @Prop({ type: String, required: true })
    public readonly titleheight!: string
    @Prop({ type: String, required: true })
    public readonly bodyheight!: string
    @Prop({ type: String, required: true })
    public readonly currentTab!: string
    @Prop({ type: Boolean, required: false })
    public readonly isAdmin?: boolean
    @Prop({ type: Boolean, required: false })
    public readonly isEditing?: boolean
    @Prop({ type: Boolean, required: false })
    public readonly hideEditBtn?: boolean
    @Prop({ type: Boolean, required: false })
    public readonly installed?: boolean

    @Getter public isShowLaunchPad

    public imageCdnBaseUrl: string = imageCdnBaseUrl

    public get getTitleHeight(): string {
        return 'height: ' + this.titleheight
    }

    public get getBodyHeight(): string {
        return 'height: ' + this.bodyheight
    }

    public get getPngType(): boolean {
        return (
            typeof this.app.image === 'string' &&
            this.app.image.split('.').pop() === 'png'
        )
    }

    public get getRelatedAppPosition(): string {
        if (['auto', '0px'].includes(this.titleheight)) {
            return 'top: 33px'
        }
        const textHeight =
            (parseInt(this.titleheight, 10) + parseInt(this.bodyheight, 10)) / 2
        return 'top: ' + textHeight + 'px'
    }

    public redirectTo() {
        scrollToTop()
        const redirectURL = `/appstore/${this.currentTab}/${this.app.name}/${
            this.installed ? 'configure' : 'overview'
        }`
        if (this.isShowLaunchPad) {
            // Redirect from dashboard rather than appstore internally
            window.location.href = `${window.location.origin}${redirectURL}`
        } else {
            this.$router.push(redirectURL)
        }
    }

    public clickAppTile() {
        // for research panel, it's just an external link
        if (this.app.name === 'research-panel') {
            (window as any).open(this.app.app_link, '_blank').focus()
            return
        }
        this.isEditing ? this.$emit('relatedApp') : this.redirectTo()
    }
}
